import { useCallback, type ReactNode } from 'react'
import styled from 'styled-components'

import { Button, Icon, Layout, Text, Tooltip } from '@loadsmart/miranda-react'

import { useAnalytics } from 'core/analytics/useAnalytics'

import { screen } from 'legacy/styles/screen'
import user from 'legacy/utils/user'

const StyledLayoutBox = styled(Layout.Box)`
  display: flex;
  flex: 1;
  min-height: 300px;
  max-height: 300px;

  ${screen.md} {
    min-height: 100%;
    max-height: 100%;
    height: 0;
    min-width: 300px;
  }
`

export type LocationPingsCardProps = {
  readonly children: ReactNode
  readonly trackingLink?: string | null
}

export function LocationPingsCard({ trackingLink, children }: LocationPingsCardProps) {
  const { track } = useAnalytics()

  const openExternalProviderLink = useCallback(() => {
    if (trackingLink) {
      track('Opened: External provider logs', { source: 'location pings button' })
      window.open(trackingLink, '_blank', 'noopener')
    }
  }, [trackingLink, track])

  return (
    <StyledLayoutBox
      backgroundColor="color-background-primary"
      borderRadius="border-radius-m"
      borderWidth="border-thin"
      borderColor="color-border"
    >
      <Layout.Stack gap="spacing-6" justify="center" style={{ width: '100%' }}>
        <Layout.Group justify="space-between" align="center">
          <Text variant="body-md-bold">Pings</Text>
          {!user.isLoggedIn() && trackingLink && (
            <Tooltip message="Open external provider link" placement="top">
              <Button
                aria-label="Open external provider link"
                variant="icon"
                size="small"
                aria-haspopup="true"
                onClick={openExternalProviderLink}
              >
                <Icon name="export" size="16px" color="color-text-primary" />
              </Button>
            </Tooltip>
          )}
        </Layout.Group>
        <Layout.Stack gap="spacing-6" style={{ width: '100%', height: '100%', overflow: 'auto' }}>
          {children}
        </Layout.Stack>
      </Layout.Stack>
    </StyledLayoutBox>
  )
}
